module.exports = __webpack_public_path__ + "static/media/button-sound.50afc132.mp3";